import { makeStyles } from 'tss-react/mui';

export const LoginPageStyles = makeStyles()({
    mainOuterCtn: {
        flexDirection: "column",
        flexWrap: "nowrap",
    },

    mainBlockCtn: {
        height: "calc(100vh - 149px)",
        maxHeight: "calc(100vh - 149px)",
        overflowY: "auto",
        background: "linear-gradient(145deg, #EEF3FF 0%, #F8FAFF 55%, #EAF4FF 100%)",
    },

    mainBlock: {
        minHeight: "100%",
        padding: "40px 20px",
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
    },

    signInBox: {
        borderRadius: "20px",
        width: "460px",
        background: "#FFFFFF",
        boxShadow: "0px 8px 40px rgba(59, 120, 206, 0.10), 0px 2px 12px rgba(0, 0, 0, 0.05)",
        padding: "44px 48px 40px",
        display: "flex",
        flexDirection: "column",
    },

    cardHeader: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginBottom: "28px",
    },

    logoInCard: {
        width: "148px",
        height: "34px",
        objectFit: "contain",
        marginBottom: "22px",
    },

    heading: {
        color: "#0E0E23",
        fontSize: "24px",
        fontWeight: "700",
        letterSpacing: "-0.4px",
        lineHeight: 1.25,
        textAlign: "center",
    },

    subheading: {
        color: "#6C6C6C",
        fontSize: "14px",
        fontWeight: "400",
        marginTop: "6px",
        textAlign: "center",
        lineHeight: 1.5,
    },

    btnCtn: {
        display: "flex",
        flexDirection: "row",
        gap: "12px",
        width: "100%",
    },

    signInButton: {
        flex: 1,
        height: "44px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#3D3D3D",
        fontSize: "14px",
        fontWeight: "500",
        borderRadius: "10px",
        border: "1.5px solid #E2E8F0",
        background: "#FAFAFA",
        gap: "8px",
        textTransform: "none",
        lineHeight: "normal",
        "&:hover": {
            background: "#F1F5F9",
            borderColor: "#C0CCDA",
            boxShadow: "none",
        },
    },

    logoImg: {
        width: "18px",
        height: "18px",
        objectFit: "contain",
    },

    dividerWrapper: {
        width: "100%",
        padding: "20px 0 16px",
    },

    orDividerLabel: {
        color: "#9CA3AF",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.8px",
        paddingLeft: "12px",
        paddingRight: "12px",
    },

    formFieldsSection: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
    },

    formBusy: {
        opacity: 0.6,
        pointerEvents: "none",
        cursor: "not-allowed",
    },

    errorText: {
        color: "#d32f2f",
        fontSize: "13px",
        marginBottom: "12px",
        paddingLeft: "4px",
        paddingRight: "4px",
    },

    emailTextField: {
        marginBottom: "16px",
        "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
        },
        "& .MuiInputBase-input": {
            fontSize: "14px",
        },
        "& input:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px #ffffff inset !important",
            WebkitTextFillColor: "#0E0E23 !important",
            caretColor: "#0E0E23",
            borderRadius: "10px",
            transition: "background-color 5000s ease-in-out 0s",
        },
    },

    otpInputWrapper: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        marginBottom: "4px",
        "& .ant-otp": {
            gap: "10px",
        },
        "& .ant-otp-input": {
            width: "44px",
            height: "44px",
            borderRadius: "10px",
            fontSize: "18px",
            fontWeight: 600,
        },
    },

    otpFieldError: {
        color: "#d32f2f",
        fontSize: "12px",
        marginTop: "4px",
        marginBottom: "8px",
        textAlign: "center",
    },

    emailSignInBtn: {
        width: "100%",
        height: "46px",
        background: "linear-gradient(135deg, #3B78CE 0%, #2a5fa8 100%)",
        color: "#fff",
        fontSize: "15px",
        fontWeight: "600",
        borderRadius: "10px",
        marginTop: "20px",
        textTransform: "none",
        boxShadow: "0px 4px 16px rgba(59, 120, 206, 0.30)",
        letterSpacing: "0.2px",
        "&:hover": {
            background: "linear-gradient(135deg, #2a5fa8 0%, #1e4a8a 100%)",
            boxShadow: "0px 6px 20px rgba(59, 120, 206, 0.40)",
        },
        "&:disabled": {
            background: "#b8cde8",
            color: "#fff",
            boxShadow: "none",
        },
    },

    spinner: {
        color: "#fff",
    },

    resendSpinner: {
        color: "#3B78CE",
    },

    otpHint: {
        color: "#6C6C6C",
        fontSize: "13px",
        marginBottom: "16px",
        lineHeight: 1.5,
        textAlign: "center",
    },

    textActionButton: {
        marginTop: "12px",
        textTransform: "none",
        fontSize: "13px",
        fontWeight: 500,
        color: "#3B78CE",
    },

    resendOtpButton: {
        marginTop: "16px",
        height: "44px",
        textTransform: "none",
        fontSize: "14px",
        fontWeight: 600,
        borderRadius: "10px",
        border: "1.5px solid #3B78CE !important",
        color: "#3B78CE",
        backgroundColor: "#FFFFFF",
        "&:hover": {
            backgroundColor: "#EEF3FF",
            borderColor: "#2a5fa8 !important",
        },
        "&:disabled": {
            borderColor: "#C0CCDA !important",
            color: "#9CA3AF",
            backgroundColor: "#FAFAFA",
        },
    },
});
